'use strict';

var React = require('react');
var Picture = require('../elements/Picture');
var NewsUrgentListItem = require('./NewsUrgentListItem.jsx');
var NewsTopStory = require('./NewsTopStory.jsx');

var classnames = require('classnames');

class NewsUrgent extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		var hero = this.props.hero;
		var teasers = this.props.teasers;
		//var screamer = this.props.screamer;
		var banner = this.props.banner;
		var topStory = this.props.topStory;
		var destination = this.props.destination;

		if (!hero) {
			return (
				<NewsTopStory model={topStory} />
			);
		}

		var teasersLength = teasers.size;
		var teasersDivider = Math.ceil(teasersLength / 2);
		var teasersFirstItems = teasers.slice(0, teasersDivider);
		var teasersLastItems = teasers.slice(teasersDivider, teasersLength);

		var className;
		var textClass = "svtse_news-urgent-text";
		var labelBig;
		var labelNormal = "svtse_news-urgent-label-hide";

		// If image is to the left
		if (destination.get('bannerSize') === 'normal') {
			className = "svt_mediablock__fig svt_mediablock__fig--O-L-L-L svt_mediablock__fig--large";
			textClass = "svtse_news-urgent-text svt_mediablock__text";
			labelBig = "svtse_news-urgent-label-hide";
			labelNormal = "svtse_news-urgent-label-show";
		}

		// If it's News or Sports
		var newsDestination = destination.get('bannerDestination');
		var destinationLabel = "SVT NYHETER";

		var isSport = newsDestination === 'SPORT'; // || hero.targetUrl.indexOf("/sport/") > -1);

		// Hängslen
		if(!isSport && hero.targetUrl && hero.targetUrl.indexOf("/sport/") > -1){
			isSport = true;
		}

		var prefixClassNames = classnames({
			'svtse_news-urgent-label__prefix': true,
			'svtse_news-urgent-label__prefix--rightborder': true,
			'svtse_news-urgent-label__prefix--theme-sport': isSport
		});

		if (isSport) {
			destinationLabel = 'SVT SPORT';
		}

		/* For screen readers, we only show the most relevant information in teaser */
		var ariaText = hero.title + ", " + hero.text;

		return (
			<section className="svtse_section svtse_section--top-story">
				<article className="svtse_news-urgent">
					<h1 className="svtse_a11y-hidden">Toppnyheter från {destinationLabel}</h1>
					<div className={labelBig}>
						<a className="svtse_news-urgent__link" href={banner.get('targetUrl')}>
							<h2 className="svtse_news-urgent-label__headline">
								<span className={prefixClassNames} aria-hidden="true">{destinationLabel}</span>
								<span className="svtse_news-urgent__headline-text">{banner.get('title')}</span>
							</h2>
						</a>
					</div>
					<a className="svtse_news-urgent-link" href={hero.targetUrl} aria-label={ariaText}>
						<div className="svt_mediablock">
							<Picture model={hero.cover} type="extralarge_cinema" className={className} />
							<div className={textClass}>

								<div className={labelNormal}>
									<h2 className="svtse_news-urgent-label__headline">
										<span className={prefixClassNames} aria-hidden="true">{destinationLabel}</span>
										{banner.get('title')}
									</h2>
								</div>

								<h3 className="svtse_news-urgent-text__headline">
									{hero.title}
								</h3>
								<p className="svtse_news-urgent-text__bread">{hero.text}</p>
							</div>
						</div>
					</a>

					<aside className="svtse_news-urgent-aside">
						<div className="svtse_grid">
							<div className="svtse_grid__col-full-halves--medium svtse_grid--no-top-padding">
								{teasersFirstItems.map(function(teasersFirstItems, firstItemsIndex){
									return (
										<ul className="svtse_news-urgent-aside__list" key={firstItemsIndex}>
											<NewsUrgentListItem title={teasersFirstItems.get('title')} target={teasersFirstItems.get('targetUrl')}  />
										</ul>
									);
								})}
							</div>
							<div className="svtse_grid__col-full-halves--medium svtse_grid--no-top-padding">
								{teasersLastItems.map(function(teasersLastItems, lastItemsIndex){
									return (
										<ul className="svtse_news-urgent-aside__list" key={lastItemsIndex}>
											<NewsUrgentListItem title={teasersLastItems.get('title')} target={teasersLastItems.get('targetUrl')}  />
										</ul>
									);
								})}
							</div>
						</div>

					</aside>
				</article>

			</section>
		);
	}
}

NewsUrgent.propTypes = {
	hero: React.PropTypes.object,
	teasers: React.PropTypes.object,
	//screamer: React.PropTypes.object,
	banner: React.PropTypes.object,
	topStory: React.PropTypes.object,
	destination: React.PropTypes.object
};

module.exports = NewsUrgent;



/** WEBPACK FOOTER **
 ** ./app/components/news/NewsUrgent.jsx
 **/